export default "__VITE_ASSET__BnZi5uCm__"